<template>
  <div class="page-title" :class="{ 'page-title-visibility': step > 1 }">
    <h1 class="page-title-header">{{ $t("title") }}</h1>
    <h2 class="page-title-subheader">
      <i18n path="subtitle">
        <br />
      </i18n>
    </h2>
  </div>
</template>
<script>
import "./PageTitle.scss";

export default {
  name: "Title",
  props: {
    step: {
      type: Number,
      required: true,
    },
  },
};
</script>
